import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  signaturesExpiring: "Signatures expiring",
  signaturesExpiringDescription: "Signing links that expire within 48 hours",
  sent: (ago: string) => `Sent ${ago}`,
  noExpiring: "No signing links expire in the next 48 hours.",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    signaturesExpiring: "Signatures arrivant à expiration",
    signaturesExpiringDescription: "Liens de signature qui expirent dans les 48 heures",
    sent: (ago) => `Envoyé ${ago}`,
    noExpiring: "Aucun lien de signature n'expire dans les 48 prochaines heures.",
  },
  es_ES: {
    signaturesExpiring: "Firmas a punto de caducar",
    signaturesExpiringDescription: "Enlaces de firma que caducan en las próximas 48 horas",
    sent: (ago) => `Enviado ${ago}`,
    noExpiring: "Ningún enlace de firma caduca en las próximas 48 horas.",
  },
  pt_BR: {
    signaturesExpiring: "Assinaturas a expirar",
    signaturesExpiringDescription: "Links de assinatura que expiram em até 48 horas",
    sent: (ago) => `Enviado ${ago}`,
    noExpiring: "Nenhum link de assinatura expira nas próximas 48 horas.",
  },
  de_DE: {
    signaturesExpiring: "Ablaufende Signaturen",
    signaturesExpiringDescription: "Signaturlinks, die innerhalb von 48 Stunden ablaufen",
    sent: (ago) => `Gesendet ${ago}`,
    noExpiring: "In den nächsten 48 Stunden laufen keine Signaturlinks ab.",
  },
  it_IT: {
    signaturesExpiring: "Firme in scadenza",
    signaturesExpiringDescription: "Link di firma che scadono entro 48 ore",
    sent: (ago) => `Inviato ${ago}`,
    noExpiring: "Nessun link di firma scade nelle prossime 48 ore.",
  },
  ar: {
    signaturesExpiring: "توقيعات على وشك الانتهاء",
    signaturesExpiringDescription: "روابط التوقيع الإلكتروني التي تنتهي صلاحيتها خلال 48 ساعة",
    sent: (ago) => `أُرسل ${ago}`,
    noExpiring: "لا توجد روابط توقيع إلكتروني تنتهي صلاحيتها خلال الـ 48 ساعة القادمة.",
  },
  ja_JP: {
    signaturesExpiring: "期限切れ間近の署名",
    signaturesExpiringDescription: "48 時間以内に期限切れとなる電子署名リンク",
    sent: (ago) => `${ago}に送信`,
    noExpiring: "今後 48 時間以内に期限切れとなる電子署名リンクはありません。",
  },
  hi_IN: {
    signaturesExpiring: "समाप्त हो रहे हस्ताक्षर",
    signaturesExpiringDescription: "48 घंटे के भीतर समाप्त होने वाले ई-हस्ताक्षर लिंक",
    sent: (ago) => `${ago} भेजा गया`,
    noExpiring: "अगले 48 घंटों में कोई ई-हस्ताक्षर लिंक समाप्त नहीं हो रहा है।",
  },
  zh_CN: {
    signaturesExpiring: "即将过期的签署",
    signaturesExpiringDescription: "将在 48 小时内过期的电子签名链接",
    sent: (ago) => `${ago}发送`,
    noExpiring: "未来 48 小时内没有即将过期的电子签名链接。",
  },
  zh_TW: {
    signaturesExpiring: "即將到期的簽署",
    signaturesExpiringDescription: "將於 48 小時內到期的電子簽名連結",
    sent: (ago) => `${ago}傳送`,
    noExpiring: "未來 48 小時內沒有即將到期的電子簽名連結。",
  },
  nl_NL: {
    signaturesExpiring: "Verlopende ondertekeningen",
    signaturesExpiringDescription: "Ondertekeningslinks die binnen 48 uur verlopen",
    sent: (ago) => `Verzonden ${ago}`,
    noExpiring: "Er verlopen de komende 48 uur geen ondertekeningslinks.",
  },
  nb_NO: {
    signaturesExpiring: "Signaturer som utløper",
    signaturesExpiringDescription: "Signeringslenker som utløper innen 48 timer",
    sent: (ago) => `Sendt ${ago}`,
    noExpiring: "Ingen signeringslenker utløper de neste 48 timene.",
  },
  sv_SE: {
    signaturesExpiring: "Signaturer som löper ut",
    signaturesExpiringDescription: "Signeringslänkar som löper ut inom 48 timmar",
    sent: (ago) => `Skickad ${ago}`,
    noExpiring: "Inga signeringslänkar löper ut de närmaste 48 timmarna.",
  },
  fi_FI: {
    signaturesExpiring: "Vanhenevat allekirjoitukset",
    signaturesExpiringDescription: "Allekirjoituslinkit, jotka vanhenevat 48 tunnin kuluessa",
    sent: (ago) => `Lähetetty ${ago}`,
    noExpiring: "Yksikään allekirjoituslinkki ei vanhene seuraavan 48 tunnin aikana.",
  },
  da_DK: {
    signaturesExpiring: "Signaturer, der udløber",
    signaturesExpiringDescription: "Signeringslinks, der udløber inden for 48 timer",
    sent: (ago) => `Sendt ${ago}`,
    noExpiring: "Ingen signeringslinks udløber inden for de næste 48 timer.",
  },
  is_IS: {
    signaturesExpiring: "Undirritanir að renna út",
    signaturesExpiringDescription: "Undirritunartenglar sem renna út innan 48 klukkustunda",
    sent: (ago) => `Sent ${ago}`,
    noExpiring: "Engir undirritunartenglar renna út næstu 48 klukkustundir.",
  },
};
